import React from 'react';

export default ({ half, ...rest }) => (
  <div className={`spacer ${half ? 'half' : ''}`} {...rest} />
);



// WEBPACK FOOTER //
// ./src/components/Space.js